import Svg, { Path } from 'react-native-svg';
import { IconProps } from './types';
import { FC } from 'react';
import { colors } from '../constants';
import { StyleProp, ViewStyle } from 'react-native';

export const Spinner: FC<IconProps & { style?: StyleProp<ViewStyle> }> = ({
  width = 60,
  height = 60,
  color = colors.gray2,
  ...rest
}) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      {...rest}
    >
      <Path
        d="M30 55C26.5833 55 23.3542 54.3438 20.3125 53.0312C17.2708 51.7188 14.6146 49.9271 12.3438 47.6562C10.0729 45.3854 8.28125 42.7292 6.96875 39.6875C5.65625 36.6458 5 33.4167 5 30C5 26.5417 5.65625 23.3021 6.96875 20.2812C8.28125 17.2604 10.0729 14.6146 12.3438 12.3438C14.6146 10.0729 17.2708 8.28125 20.3125 6.96875C23.3542 5.65625 26.5833 5 30 5C30.7083 5 31.3021 5.23958 31.7812 5.71875C32.2604 6.19792 32.5 6.79167 32.5 7.5C32.5 8.20833 32.2604 8.80208 31.7812 9.28125C31.3021 9.76042 30.7083 10 30 10C24.4583 10 19.7396 11.9479 15.8438 15.8438C11.9479 19.7396 10 24.4583 10 30C10 35.5417 11.9479 40.2604 15.8438 44.1562C19.7396 48.0521 24.4583 50 30 50C35.5417 50 40.2604 48.0521 44.1562 44.1562C48.0521 40.2604 50 35.5417 50 30C50 29.2917 50.2396 28.6979 50.7188 28.2188C51.1979 27.7396 51.7917 27.5 52.5 27.5C53.2083 27.5 53.8021 27.7396 54.2812 28.2188C54.7604 28.6979 55 29.2917 55 30C55 33.4167 54.3438 36.6458 53.0312 39.6875C51.7188 42.7292 49.9271 45.3854 47.6562 47.6562C45.3854 49.9271 42.7396 51.7188 39.7188 53.0312C36.6979 54.3438 33.4583 55 30 55Z"
        fill={color}
      />
    </Svg>
  );
};
